export default __webpack_public_path__ + "static/media/6.aaf7c5a5.jpg";